// extracted by mini-css-extract-plugin
module.exports = {"container":"TabSwitcherItem_container__b7XGP","value":"TabSwitcherItem_value__NJnY9"};